import { Formik } from "formik";
import { Form } from "react-bootstrap";
import { Button } from '@blueprint/ui';
import * as yup from "yup";

import { Loader } from "../../../common/components/core";
import {
    FormContainer,
    FormFooter,
    InputField,
} from "../../../common/components/form";
import { FormSubmissionHandler } from "../../../types/common";
import { Profile } from "../ProfileDetailView";

export type UpdateProfileFormValues = {
    profileName: string;
    profileType: string;
    profileCountryCity: string;
    contactPersonName: string;
    contactPersonNumber: string;
    contactPersonEmail: string;
};

const schema: yup.SchemaOf<UpdateProfileFormValues> = yup.object().shape({
    profileType: yup.string().required(),
    profileName: yup.string().required(),
    profileCountryCity: yup.string().required(),
    contactPersonName: yup.string().required(),
    contactPersonNumber: yup.string().required(),
    contactPersonEmail: yup.string().email().required(),
});

type CreateNewProfileFormProps = {
    data: Profile;
    onCancel: () => void;
    onSubmit: FormSubmissionHandler<UpdateProfileFormValues>;
};

const UpdateProfileForm = ({
    data,
    onCancel,
    onSubmit,
}: CreateNewProfileFormProps): JSX.Element => {
//     data.profileType = generateProfileType(data.profileType);
    return (
        <Formik
            validationSchema={schema}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={onSubmit}
            initialValues={data}
        >
            {({ handleSubmit, isSubmitting, setFieldValue, values }) => (
                <Loader isLoading={isSubmitting}>
                    <FormContainer>
                        <h1 className="mb-2 rem-1-5">Details for Profile</h1>
                        <Form
                            autoComplete="off"
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <fieldset>
                                <InputField
                                    name="profileType"
                                    label="Profile Type"
//                                     options={allProfileTypes}
                                    type="text"
                                    disabled
                                    required={true}
                                />
                                <InputField
                                    name="profileName"
                                    label="Profile Name"
                                    type="text"
                                    disabled
                                    required={true}
                                />
                                <InputField
                                    name="profileCountryCity"
                                    label="Profile Country & City"
//                                     options={countryCityOptions}
                                    type="text"
                                    disabled
                                    required={true}
                                />
                            </fieldset>
                            <div>
                                <hr className="bg-border-grey my-3" />
                                <h1 className="mb-2 rem-1-5">Details for Profile Contact Person</h1>
                            </div>
                            <InputField
                                name="contactPersonName"
                                label="Contact Person Name"
                                type="text"
                                maxLength={30}
                                onBlur={() =>
                                    setFieldValue(
                                        "contactPersonName",
                                        values.contactPersonName.trim(),
                                    )
                                }
                                required={true}
                            />
                            <InputField
                                name="contactPersonNumber"
                                label="Contact Person Number"
                                type="text"
                                maxLength={20}
                                onBlur={() =>
                                    setFieldValue(
                                        "contactPersonName",
                                        values.contactPersonName.trim(),
                                    )
                                }
                                required={true}
                            />
                            <InputField
                                name="contactPersonEmail"
                                label="Contact Person Email address"
                                type="text"
                                maxLength={50}
                                onBlur={() =>
                                    setFieldValue(
                                        "contactPersonEmail",
                                        values.contactPersonEmail.trim(),
                                    )
                                }
                                required={true}
                            />
                            <FormFooter className="d-flex justify-content-between pt-5">
                                <Button
                                    variant="light.tertiary"
                                    onClick={onCancel}
                                >
                                    Cancel
                                </Button>
                                <Button variant="light.primary" type="submit">
                                    Save
                                </Button>
                            </FormFooter>
                        </Form>
                    </FormContainer>
                </Loader>
            )}
        </Formik>
    );
};

export default UpdateProfileForm;
